import { Color } from 'three';
import { IGradient } from '../types';

export const VIRIDIS: IGradient = [
  [0.0, new Color(0.267, 0.005, 0.329)],
  [0.1, new Color(0.283, 0.141, 0.458)],
  [0.2, new Color(0.254, 0.265, 0.53)],
  [0.3, new Color(0.207, 0.372, 0.553)],
  [0.4, new Color(0.164, 0.471, 0.558)],
  [0.5, new Color(0.128, 0.567, 0.551)],
  [0.6, new Color(0.135, 0.659, 0.518)],
  [0.7, new Color(0.267, 0.749, 0.441)],
  [0.8, new Color(0.478, 0.821, 0.318)],
  [0.9, new Color(0.741, 0.873, 0.15)],
  [1.0, new Color(0.993, 0.906, 0.144)],
];
